import * as React from 'react';
import { IconPlus16, Button } from '@cian/ui-kit';

import { trackOpenFeedbackForm } from '../../utils/analytics';
import { TFeedbackProps } from './container';
import { FeedbackModal } from './modal';

import * as styles from './index.css';

export class FeedbackBlock extends React.Component<TFeedbackProps> {
  public render() {
    const { hint, sendFeedbackAction, isFeedbackPopupOpened, isMobile } = this.props;
    const notEmpty = (hint && hint.regionHasVillages) || !hint;

    if (!notEmpty) {
      return null;
    }

    return (
      <div>
        <div>
          {isMobile ? (
            <button className={styles['button']} onClick={this.handleModalOpening}>
              <IconPlus16 color="primary_100" />
              <div className={styles['button-text']}>Добавить посёлок в каталог</div>
            </button>
          ) : (
            <Button
              onClick={this.handleModalOpening}
              type="button"
              theme="fill_white_primary"
              size="XS"
              beforeIcon={<IconPlus16 color="primary_100" />}
            >
              Добавить посёлок в каталог
            </Button>
          )}
        </div>
        {isFeedbackPopupOpened && (
          <FeedbackModal
            onModalClose={this.handleModalClose}
            sendFeedbackAction={sendFeedbackAction}
            isMobile={isMobile}
          />
        )}
      </div>
    );
  }

  private handleModalOpening = () => {
    this.props.showFeedbackPopup(true);
    trackOpenFeedbackForm();
  };

  private handleModalClose = () => this.props.showFeedbackPopup(false);
}
